import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdvertorialPage } from './pages/AdvertorialPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/5-razones" element={<AdvertorialPage data-id="element-3" />} data-id="element-2" />
        <Route path="*" element={<Navigate to="/5-razones" replace data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}